import Label from "lib/Label";
import React from "react";
import { Col } from "react-bootstrap";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { bankInfo, getBankList, getCountriesCode} from "api/formDisplay";
import { setLoadingState } from "redux/staticData";
import { CheckForIndianResident } from "helper/calculateNetAsset";
import { setIsConditional, setRoleId,setActiveStep,setUserId } from "redux/popupReducer";
import {mergeFields} from "helper/triggerButtonCallback"
import { clearSelectedDataKey, clearSpecificFields } from "redux/formDisplay";
import { mandateDetails } from "constants/mandateDetails";

const DropdownV1 = (props) => {
  var {
    options,
    options_type,
    label,
    web_grid_col,
    mobile_grid_col,
    onChange,
    placeholder,
    name,
    value: userValue,
    class_name,
    togglecopy,
    togglesublable,
    error,
    copyToClipboard,
    selectedData,
    setSelectedData,
    size,
    isEditable,
    is_disabled,
    validators,
    events,
    workFlowCreatedBy,
    request_change_option,
    role,
    user,
    notification,
    show,
    approval_type
  
    // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  } = props;
    const formData = useSelector((state) => state.formData.selectedData);    
  const dispatch = useDispatch();
  const countryData = useSelector((state) => state.staticData?.countryData);
  const bankList = useSelector((state) => state.staticData?.bankList);
  const status = useSelector((state) => state.staticData?.status);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const isToggled = useSelector((state) => state.formData.isToggled);
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  //console.log("primaryUser",primaryUser);
  const subworkflows= primaryUser?.source_data?.subworkflows
  const popupReducer = useSelector((state) => state.popupReducer?.popupData);
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const userInfo = useSelector((state) => state.userInfo);
  const config = useSelector(( state) => state.configurationReducer?.config);
  const all_users = useSelector((state)=> state.dashboardReducer?.allUsers)
  const all_roles =  useSelector ((state)=>state.dashboardReducer?.allRoles)
  const role_info = useSelector((state)=>state.dashboardReducer?.rolesInfo)
  // const step_history = useSelector((state) => state.)
  const recursiveFormData = useSelector(
    (state) => state.recursive.recursiveFormData
  );
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const moduleId = useSelector((state) => state?.dashboardDetailReducer?.dashboardDetailConfiguration?.configurationInfo?.module_id);
 const userSubworkFlowInfo =useSelector((state)=>state?.dashboardDetailReducer?.userSubworkFlowInfo)
const role_id = useSelector((state)=> state?.popupReducer?.role_id[0]);
const assign_approval_to = useSelector((state)=>state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow?.source_data?.assign_approval_user_id);
const move_to_the_step = useSelector((state)=> state?.popupReducer?.move_to_the_step);
const assigned_dynamic_step = useSelector((state)=>state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow?.source_data?.assigned_dynamic_step);

  const search = window.location.search;
  const query = new URLSearchParams(search);

  const trigger = React.useMemo(() => {
    return query.get("trigger");
  }, [search, query]);
  const wfJourney = useSelector(
    (state) => state?.configurationReducer?.config?.wf_journey
  );
  const [popupState, setPopupState] = useState({});
  if (countryData?.length == 0 && status == false) {
    dispatch(setLoadingState(true));
    dispatch(getCountriesCode());
  }
  useEffect(() => {
    if(options_type == "getBankList"){
      let mandatepurpose = mandateDetails.mandateVariant.find((item) => item.label === selectedData?.authentication_mode);
      let payload = {
        organisation_id : config?.organisation_id,
        authentication_mode : mandatepurpose.value
      }
      dispatch(getBankList(payload))
    }
  },[selectedData?.authentication_mode])
 

  if (options_type == "getBankList") {
    options = [];
    options.push({ label: "Select", value: "" });
    for (let i in bankList) {
      let paramObj = {};
      if ("bank_name" in bankList[i]) {
        paramObj.label = bankList[i].bank_name;
        paramObj.value = bankList[i].bank_code;  
        options.push(paramObj);
      }
    }
  }
 

 

  if (options_type == "globalCountries") {
    options = [];
    options.push({ label: "Select", value: "" });
    for (let i in countryData) {
      let paramObj = {};
      if ("country_name" in countryData[i]) {
        paramObj.label = countryData[i].country_name;
        paramObj.value = countryData[i].country_name;
        options.push(paramObj);
      }
    }
  }
  if (options_type == "globalNationality") {
    options = [];
    options.push({ label: "Select", value: "" });
    for (let i in countryData) {
      let paramObj = {};
      if ("nationality" in countryData[i]) {
        paramObj.label = countryData[i].nationality;
        paramObj.value = countryData[i].nationality;
        options.push(paramObj);
      }
    }
  }
  if (options_type == "countryCode") {
    options = [];
    options.push({ label: "Select", value: "" });
    for (let i in countryData) {
      let paramObj = {};
      if ("calling_code" in countryData[i]) {
        paramObj.label = `(${countryData[i].calling_code}) ${countryData[i].country_name}`;
        paramObj.value = countryData[i].calling_code;  
        options.push(paramObj);
      }
    }
  }

  if (options_type === "all_roles") {
    const uniqueSteps = new Set();
    options = [{ label: "Select", value: "" }];
    
    const filteredRoles = all_roles.filter(data => {
      // if (role_id && assign_approval_to) {
      //   return data?._id === role_id;
      // } else {
        return data?.module_list.some(_item => _item?.module_id === moduleId);
      // }
    });
  
    filteredRoles.forEach(data => {
      wfJourney.forEach(item => {
        if (item?.module_settings?.approved_by?.role_id.includes(data?._id) && role_info?._id !== data?._id) {
          if (!uniqueSteps.has(data._id)) {
            options.push({
              label: data?.name,
              value: data._id,
              active_step: item?.step
            });
            uniqueSteps.add(data._id);
          }
        }
      });
    });
  }

  if (options_type === "all_approved_roles") {
    const uniqueEntries = new Set();
    options = [{ label: "Select", value: "" }];

    const wfJourneySteps = {};
    wfJourney?.forEach(journey => {
        wfJourneySteps[journey.step] = journey;
    });

    userSubworkFlowInfo?.step_history?.forEach(data => {
        const actionByUserId = data?.action_by_user_id;
        const actionByName = data?.action_by_name?.trim();

        if (
            actionByName && 
            data?.status?.includes("Approval") && 
            loggedUserId !== actionByUserId &&
            !uniqueEntries.has(actionByUserId) 
        ) {
            options.push({
                label: actionByName,
                value: actionByUserId,
                active_step: data?.active_step,
            });
            uniqueEntries.add(actionByUserId); 
        }
        // below logic will check if the step in step_history will come under approval module or not
        if (wfJourneySteps[data.active_step] && wfJourneySteps[data.active_step].module_name === "approval" && loggedUserId != data?.action_by_user_id) {
          const journeyStep = wfJourneySteps[data.active_step];
          if (actionByName && !uniqueEntries.has(actionByUserId)) {
              options.push({
                  label: actionByName,
                  value: data?.action_by_user_id,
                  active_step: data.active_step
              });
              uniqueEntries.add(actionByUserId);
          }
      }
    });
}





  
  
  
  
  if (options_type === "users") {
    const uniqueSteps = new Set();
    options = [{ label: "Select", value: "" }];
  
    const filteredRoles = all_roles.filter(data => 
      data?.module_list.some(_item => _item?.module_id === moduleId)
    );
  
    const reportingManager = all_roles.some(data => 
      data?._id === loggedInUserInfo?.profileInfo?.role &&
      data?.module_list?.some(item => item?.show_application_to === "reporting_manager")
    );
  
    const currentStep = wfJourney.find(e => e?.step == selectedData?.subworkFlowInfo?.active_step) || {};
  
    const addOption = (user, step) => {
      if (!uniqueSteps.has(user._id)) {
        options.push({
          label: `${user.profile?.first_name} ${user.profile?.last_name}`,
          value: user._id,
          active_step: step,
          user: true
        });
        uniqueSteps.add(user._id);
      }
    };
  
    filteredRoles.forEach(role => {
      wfJourney.forEach(item => {
        if (item?.module_settings?.approved_by?.role_id.includes(role?._id) && role_info?._id !== role?._id) {
          all_users.forEach(user => {
            if (reportingManager) {
              userSubworkFlowInfo?.show_application_to.forEach(data => {
                if (user?._id === data && data != loggedUserId) addOption(user, item?.step);
              });
            } else if (user?.role === role?._id) {
              addOption(user, item?.step);
            }
          });
        }
      });
    });
  }
  

 

  if(options_type === 'all_users'){
      let collaboratedDropdownData = {
        role: role?.length > 0 ? role : ["all"],
        user: user?.length > 0 ? user : ["all"],
        notification: notification?.length > 0 ? notification : ["all"],
        request_change_option: request_change_option
          ? request_change_option
          : "user",
      };
      const getDropDownValuesBasedOnConfig = (item) => {
        if (item?.request_change_option === "user") {
          if (item?.user?.includes("all") && item?.role?.includes("all")) {
            return all_users;
          } else if (item?.user?.includes("creator")) {
            let creatorList = all_users.find(
              (obj) => obj?._id === workFlowCreatedBy
            );
            return creatorList;
          } else {
            if (
              item?.role.every(
                (item) =>
                  !["all", "prev", "next", "prev_all", "next_all"].includes(item)
              ) &&
              item?.user?.includes("all")
            ) {
              let collectedUserBasedOnRole = all_users.filter((obj) =>
                item?.role?.includes(obj?.role)
              );
              return collectedUserBasedOnRole;
            } else if (
              item?.role.every(
                (item) =>
                  !["all", "prev", "next", "prev_all", "next_all"].includes(item)
              ) &&
              item?.user.every(
                (item) =>
                  !["all", "prev", "next", "prev_all", "next_all"].includes(item)
              )
            ) {
              let collectedUserBasedOnRole = all_users.filter((obj) =>
                item?.role?.includes(obj?.role)
              );
              let segrigatedUser = collectedUserBasedOnRole.filter((obj) =>
                item?.user?.includes(obj?._id)
              );
              return segrigatedUser;
            }
          }
        } else if (item?.request_change_option === "role") {
          if (item?.role?.includes("all")&&item?.user?.includes("all")) {
            return all_roles;
          }else if (item?.user?.includes("creator")){
            let creatorList = all_users.find(
              (obj) => obj?._id === workFlowCreatedBy
            );
            let roleData = all_roles.filter((obj) =>
            obj?._id === creatorList?.role
          );
            return roleData;
          }else if(
            item?.role.every(
              (item) =>
                !["all", "prev", "next", "prev_all", "next_all"].includes(item)
            ) &&
            item?.user?.includes("all")
          ) {
            let segrigatedRole = all_roles.filter((obj) =>
              item?.role?.includes(obj?._id)
            );
            return segrigatedRole;
          }
        }else{
          return all_users;
        }
      };
      let collectedData = getDropDownValuesBasedOnConfig(
        collaboratedDropdownData
      );
      options = [];
      if (request_change_option === "user" && user.includes("creator")) {
        options.push({ label: "Select", value: "" });
        let paramObj = {};
        paramObj.label =
          collectedData.profile?.first_name +
          " " +
          collectedData.profile?.last_name;
        paramObj.value = collectedData?._id;
        options.push(paramObj);
      }else{
        options.push({ label: "Select", value: "" });
        for (let i in collectedData) {
          let paramObj = {};
          if (request_change_option === "role") {
            paramObj.label = collectedData[i].name;
            paramObj.value = collectedData[i]._id;
          } else {
            paramObj.label =
              collectedData[i].profile?.first_name +
              " " +
              collectedData[i].profile?.last_name;
            paramObj.value = collectedData[i]._id;
          }
          options.push(paramObj);
        }
      }
  }

  if (options_type === "fetch_steps") {    
    options = [];
    let stepsAvailable = false;
    const uniqueIds = new Set();
    if( popupReducer?.assign_approval_to ){
    // if(popupReducer?.assign_rejection_to){      
    //   userSubworkFlowInfo?.step_history?.forEach((step) => {
    //     if (step.action_by_user_id === popupReducer?.assign_rejection_to && !uniqueIds.has(step.active_step)) {
    //         if (!stepsAvailable) {
    //             options.push({ label: "Select", value: "" });
    //             stepsAvailable = true;
    //         }
    //         options.push({ label: `Step ${step.active_step}`, value: step.active_step });
    //         uniqueIds.add(step.active_step);
    //     }
    // });
    // }else if( popupReducer?.assign_approval_to ){
      wfJourney.forEach((stepConfig) => {
        const { step, module_settings } = stepConfig;
        if (
          module_settings?.approved_by?.role_id.includes(
            popupReducer?.assign_approval_to 
          )
        ) 
        {
          const stepToAdd = assigned_dynamic_step && assigned_dynamic_step !== "undefined"
            ? assigned_dynamic_step
            : step;
    
          if (!uniqueIds.has(stepToAdd)) {
            if (!stepsAvailable) {
              options.push({ label: "Select", value: "" });
              stepsAvailable = true;
            }
    
            options.push({ label: `Step ${stepToAdd}`, value: stepToAdd });
    
            uniqueIds.add(stepToAdd);
          }
        }
      });
    }
  
   
    if (!stepsAvailable) {
      options.push({ label: "No Steps to show", value: "" });
    }
  }
  

  if (options_type === "fetch_approved_steps") {
    options = [];
    let stepsAvailable = false;
    const uniqueIds = new Set();
    if( popupReducer?.assign_rejection_to){

      userSubworkFlowInfo?.step_history.forEach((stepConfig) => {
          const { active_step, action_by_user_id } = stepConfig;
          if (action_by_user_id === popupReducer?.assign_rejection_to) {          
              const stepToAdd = assigned_dynamic_step && assigned_dynamic_step !== "undefined"
                  ? assigned_dynamic_step
                  : active_step;
  
              if (!uniqueIds.has(stepToAdd)) {
                  if (!stepsAvailable) {
                      options.push({ label: "Select", value: "" });
                      stepsAvailable = true;
                  }
  
                  options.push({ label: `Step ${stepToAdd}`, value: stepToAdd });
                  uniqueIds.add(stepToAdd);
              }
          }
      });
    }

    if (!stepsAvailable) {
        options.push({ label: "No Steps to show", value: "" });
    }
}

  


  const IndirectEval = (evalString) =>{
    return eval(evalString)
  }
  const onClick=async (item)=>{
    if(events){
     IndirectEval(events?.onClick)
    }
  }


  
  const isAnyApplicantIndian =() =>{
    return CheckForIndianResident(subworkflows)
  }
  const concatenateFields =  (data,extractedData,keyName) =>{
    mergeFields(data,extractedData,keyName,dispatch,setSelectedData)
  }
  const accountNumberValidation = (item) => {
    dispatch(bankInfo(item))
  }

  const [defaultValue, setDefaultValue] = useState();
  useEffect(() => {
    !selectedData[name] && setDefaultValue("Select");
  }, []);

  useEffect(() => {
    if(popupReducer?.["assign_rejection_to"]){
      options.map((item) => {
        if(item?.value === popupReducer?.["assign_rejection_to"]) {
          if(item?.role_id) {
            dispatch(setRoleId(item?.role_id))
            dispatch(setIsConditional(item?.is_conditional))
          }
        }
      })
    }
    else if(popupReducer?.["assign_approval_to"]){
      options.map((item) => {
        if(item?.value === popupReducer?.["assign_approval_to"]) {
          if(item?.user){
            dispatch(setUserId(item?.value))
          }else{
            dispatch(setRoleId(item?.value))
          }
          dispatch(setActiveStep(item?.active_step))
          dispatch(setIsConditional(item?.is_conditional))
        }
      })
    }
  }, [popupReducer])

  useEffect(() => {
    if (assign_approval_to) {  
      let assigned_roles = wfJourney.filter(item => {
        return item?.module_settings?.approved_by?.role_id.includes(assign_approval_to);
    });
          assigned_roles.forEach((item) => {
        if (item?.module_settings?.approved_by?.user_id?.length) {
          dispatch(setUserId(item?.module_settings?.approved_by?.user_id[0])); 
        } else if (item?.module_settings?.approved_by?.role_id?.length) {
          dispatch(setRoleId(item?.module_settings?.approved_by?.role_id[0]));  
        }
          dispatch(setActiveStep(item?.step));
        dispatch(setIsConditional(item?.is_conditional || false));
      });
    }
  }, [assign_approval_to, wfJourney]);  
  

  return (
    <div className={size}>
      <Label
        label={label}
        togglecopy={togglecopy}
        togglesublabel={togglesublable}
        copyToClipboard={copyToClipboard}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        validators={validators}
        approval_type = {approval_type}
      />
    
      <select
        className={`dropdown_container mt-0 ${errorClass} ${
          !isEditable && "radioDisabled"
        }`}
        value={
          selectedData[name]
            ? userValue?.label || selectedData[name]
            : defaultValue
        }
        onChange={onChange}
        name={name}
        id={name}
        onClick={onClick}
        placeholder={placeholder}
        disabled={
          eval(is_disabled)
            ? true
            : !isEditable ||
              (isToggled &&
                ((userValue?.label && userValue?.label?.length) ||
                  selectedData[name]?.length))
        }
      >
        {options?.map((option, index) => {
          const { label, value,is_disabled } = option;
          const show= option.show ? eval(option.show) : true;
              if(!show) return null;
          return (
            <option
              key={index}
              value={value}
              defaultValue={userValue?.label && userValue?.label == value}
              className={`dropdown_list ${eval(is_disabled) ? 'text-muted':'text-dark'}`}
              disabled = {eval(is_disabled) ? true :false}
            >
              {label}
            </option>
          );
        })}
      </select>
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </div>

  );
};

export default DropdownV1;
